import api from "api/axios";

export const fetchExhibitorCategoriesTree = (payload) =>
  api.post(`/exhibitor-category/search`, payload);

export const fetchExhibitorCategories = (companyId) =>
  api.get(`/exhibitor-category/company/${companyId}`);

export const fetchExhibitorCategoryById = (id) =>
  api.get(`/exhibitor-category/${id}`);

export const createExhibitorCategory = (data) =>
  api.post("/exhibitor-category", data);

export const updateExhibitorCategory = (id, data) =>
  api.put(`/exhibitor-category/${id}`, data);

export const deleteExhibitorCategory = (id, payload) =>
  api.put(`/exhibitor-category/delete/${id}`, payload);